var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D8DEFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 30C12 27.8783 12.8429 25.8434 14.3431 24.3431C15.8434 22.8429 17.8783 22 20 22C22.1217 22 24.1566 22.8429 25.6569 24.3431C27.1571 25.8434 28 27.8783 28 30H26C26 28.4087 25.3679 26.8826 24.2426 25.7574C23.1174 24.6321 21.5913 24 20 24C18.4087 24 16.8826 24.6321 15.7574 25.7574C14.6321 26.8826 14 28.4087 14 30H12ZM20 21C16.685 21 14 18.315 14 15C14 11.685 16.685 9 20 9C23.315 9 26 11.685 26 15C26 18.315 23.315 21 20 21ZM20 19C22.21 19 24 17.21 24 15C24 12.79 22.21 11 20 11C17.79 11 16 12.79 16 15C16 17.21 17.79 19 20 19Z",
    fill: "#5B73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/userAvatar.8045fb6805f306670c35ea13e041683a.svg";
export { ForwardRef as ReactComponent };